import { useState } from 'react';
import { api } from '../lib/api';
import { UNIT, UNIT_LABEL, type Unit } from '@artmozaik/shared';

type Satir = { key: number; supplierCode: string; description: string; qty: string; unit: Unit; unitPriceTl: string };
let sayac = 0;
const bosSatir = (): Satir => ({ key: ++sayac, supplierCode: '', description: '', qty: '', unit: 'KUTU', unitPriceTl: '' });

/**
 * ELLE ALIŞ FATURASI.
 *
 * Şartnamede yok; Paraşüt hattı açılana kadar (ve e-fatura gelmeyen
 * tedarikçiler için) stoğun donmaması gerekiyor. "Panel tek doğruluk
 * kaynağıdır" ilkesi bunu gerektiriyor.
 */
export default function YeniAlis({
  kapat, eklendi,
}: { kapat: () => void; eklendi: (id: number) => void }) {
  const [no, setNo] = useState('');
  const [tedarikci, setTedarikci] = useState('');
  const [tarih, setTarih] = useState(new Date().toISOString().slice(0, 10));
  const [satirlar, setSatirlar] = useState<Satir[]>([bosSatir()]);
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  const guncelle = (key: number, alan: Partial<Satir>) =>
    setSatirlar((s) => s.map((x) => (x.key === key ? { ...x, ...alan } : x)));

  const toplam = satirlar.reduce(
    (t, s) => t + (Number(s.qty) || 0) * (Number(s.unitPriceTl) || 0), 0
  );

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null); setBekliyor(true);
    try {
      const r = await api<{ id: number }>('/api/alis/elle', {
        method: 'POST',
        body: JSON.stringify({
          no, tedarikci, tarih,
          satirlar: satirlar
            .filter((s) => s.description && s.qty)
            .map((s) => ({
              supplierCode: s.supplierCode || undefined,
              description: s.description,
              qty: Number(s.qty),
              unit: s.unit,
              unitPriceTl: Number(s.unitPriceTl) || 0,
            })),
        }),
      });
      eklendi(r.id);
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Kaydedilemedi');
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <div className="ccd-drawer-arka" onClick={kapat} role="presentation">
      <aside className="ccd-drawer" onClick={(e) => e.stopPropagation()}
             role="dialog" aria-modal="true" aria-label="Elle alış faturası">
        <form className="ccd-stack" onSubmit={gonder}>
          <div className="ccd-row-between">
            <div>
              <div className="ccd-eyebrow">Alış</div>
              <h2 className="ccd-heading">Elle alış faturası</h2>
            </div>
            <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={kapat}>Kapat</button>
          </div>

          <div className="ccd-banner">
            <span className="ccd-banner-icon" aria-hidden="true">i</span>
            <div className="ccd-meta">
              Kaydedince satırlar <b>bağlanmayı bekler</b>. Ürüne bağladığınızda stok girer
              ve fiyat geçmişi yazılır.
            </div>
          </div>

          <div className="ccd-form-grid">
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="fno">
                Fatura no<span className="ccd-required"> *</span>
              </label>
              <input id="fno" className="ccd-input ccd-mono" required
                     value={no} onChange={(e) => setNo(e.target.value)} />
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="ftar">Tarih</label>
              <input id="ftar" className="ccd-input" type="date"
                     value={tarih} onChange={(e) => setTarih(e.target.value)} />
            </div>
          </div>

          <div className="ccd-field">
            <label className="ccd-field-label" htmlFor="fted">
              Tedarikçi<span className="ccd-required"> *</span>
            </label>
            <input id="fted" className="ccd-input" required placeholder="Evdema"
                   value={tedarikci} onChange={(e) => setTedarikci(e.target.value)} />
            <div className="ccd-field-hint">Kayıtlı değilse kendiliğinden açılır.</div>
          </div>

          <div className="ccd-fieldset-title">Satırlar</div>
          {satirlar.map((s) => (
            <div key={s.key} className="ccd-card ccd-stack-sm">
              <div className="ccd-form-grid">
                <div className="ccd-field">
                  <label className="ccd-field-label">Tedarikçi kodu</label>
                  <input className="ccd-input ccd-mono" placeholder="A45-200"
                         value={s.supplierCode}
                         onChange={(e) => guncelle(s.key, { supplierCode: e.target.value })} />
                </div>
                <div className="ccd-field">
                  <label className="ccd-field-label">Açıklama</label>
                  <input className="ccd-input" value={s.description}
                         onChange={(e) => guncelle(s.key, { description: e.target.value })} />
                </div>
              </div>
              <div className="ccd-form-grid">
                <div className="ccd-field">
                  <label className="ccd-field-label">Miktar</label>
                  <input className="ccd-input" type="number" inputMode="decimal" step="any" value={s.qty}
                         onChange={(e) => guncelle(s.key, { qty: e.target.value })} />
                </div>
                <div className="ccd-field">
                  <label className="ccd-field-label">Birim</label>
                  <select className="ccd-select" value={s.unit}
                          onChange={(e) => guncelle(s.key, { unit: e.target.value as Unit })}>
                    {UNIT.map((u) => <option key={u} value={u}>{UNIT_LABEL[u]}</option>)}
                  </select>
                </div>
                <div className="ccd-field">
                  <label className="ccd-field-label">Birim fiyat (TL)</label>
                  <input className="ccd-input" type="number" inputMode="decimal" step="any" value={s.unitPriceTl}
                         onChange={(e) => guncelle(s.key, { unitPriceTl: e.target.value })} />
                </div>
              </div>
              {satirlar.length > 1 && (
                <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm"
                        onClick={() => setSatirlar((x) => x.filter((y) => y.key !== s.key))}>
                  Satırı sil
                </button>
              )}
            </div>
          ))}

          <button type="button" className="ccd-btn ccd-btn-sm"
                  onClick={() => setSatirlar((s) => [...s, bosSatir()])}>
            + Satır ekle
          </button>

          {hata && (
            <div className="ccd-banner ccd-banner-danger">
              <span className="ccd-banner-icon" aria-hidden="true">!</span><span>{hata}</span>
            </div>
          )}

          <button className="ccd-btn ccd-btn-primary ccd-btn-lg" disabled={bekliyor}>
            {bekliyor ? 'Kaydediliyor…' : `Faturayı kaydet · ${toplam.toLocaleString('tr-TR')} ₺`}
          </button>
        </form>
      </aside>
    </div>
  );
}
